import { useTranslation } from 'react-i18next';

import { VaultUserLayout } from '../components/VaultUserLayout';
import { VaultHelpContent } from '../components/VaultHelpContent';

/**
 * VaultHelpPage
 *
 * Page d'aide / FAQ Coffre-Fort pour les employés (vault users),
 * accessible via VaultUserLayout.
 */
export const VaultHelpPage = () => {
  const { t } = useTranslation();

  return (
    <VaultUserLayout
      title={t('vault.help.title', 'Aide - Coffre-Fort Numérique')}
      subtitle={t('vault.help.subtitle', "Questions fréquentes et guide d'utilisation")}
      showBackButton
      backPath="/my-vaults"
    >
      <VaultHelpContent defaultAudience="employe" showAudienceFilter />
    </VaultUserLayout>
  );
};
